import * as React from "react";
import { SetStateAction, Dispatch, useState, useContext, } from "react";
import { FormComponentProps } from "antd/lib/form";
import { PercentageMask } from 'src/util/Masks/PercentageMask';
import { IPricingParametersCalculator } from "src/services/interfaces/calculator/IPricingParametersCalculator";
import { PbrInputPercentage } from "src/components/common/PbrInputPercentageCalculator/PbrInputPercentage";
import { PbrInputMoney } from "src/components/common/PbrInputMoney/PbrInputMoney";
import { Col, Radio } from "antd";
import { ValidateCommissionFormat } from "src/util/Validations";
import { AuthContext } from "src/components/context/AuthContext";

interface ICommissionComponent {
  pricingParameters: IPricingParametersCalculator;
  price: number,
  alignVertical: boolean
  onChange: Dispatch<SetStateAction<Partial<IPricingParametersCalculator>>>;
}

export function CommissionComponent(props: ICommissionComponent & FormComponentProps) {
  const { currentUser } = useContext(AuthContext);
  const [isCommissionAbsolute, setIsCommissionAbsolute] = useState(false);

  return (
    <>
      {currentUser.permissions.userCanSeeCommission &&
        <Col xs={24} sm={24} md={props.alignVertical ? 12 : 24} lg={props.alignVertical ? 12 : 24} style={{ marginTop: "15px" }}>
          <Radio.Group onChange={e => setIsCommissionAbsolute(e.target.value)}>
            <Radio checked={isCommissionAbsolute === false} value={false} >Comissão %</Radio>
            <Radio checked={isCommissionAbsolute === true} value={true}>Comissão R$</Radio>
          </Radio.Group>
          {isCommissionAbsolute && (
            <PbrInputMoney
              placeholder="Comissão R$"
              name="commission"
              style={{ fontSize: "15px" }}
              value={props.pricingParameters?.commission}
              onChange={e => props.onChange({ commission: ValidateCommissionFormat(e, isCommissionAbsolute, props.price), isCommissionAbsolute })}
              formWrapper={props.form}
            />
          )}

          {!isCommissionAbsolute && (
            <PbrInputPercentage
              name="commission"
              value={PercentageMask(props.pricingParameters?.commission, 2, 2)}
              placeholder="Comissão %"
              formWrapper={props.form}
              rules={[{ required: false }]}
              onChange={e => props.onChange({ commission: e, isCommissionAbsolute })}
              disabled={false}
            />
          )}
        </Col>
      }
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/PricingComponents/CommissionComponent/CommissionComponent.tsx